module.exports = __webpack_public_path__ + "img/DE00853.60a41fa1.png";